import { render, staticRenderFns } from "./Ticketsets.vue?vue&type=template&id=40166fae&scoped=true&"
import script from "./Ticketsets.vue?vue&type=script&lang=js&"
export * from "./Ticketsets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40166fae",
  null
  
)

export default component.exports